import React, {useState,useEffect} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ProviderSignup from "./ProviderSignup";
import SeekerSignup from "./SeekerSignup";
import "./SignupPage.css";
import SignupImage from "../../../asset/images/login page.png";

const SignupPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [textAnimation, setTextAnimation] = useState("fade-in");
  const isSeeker = location.state?.type === "seeker"; // Determine if the user is a seeker or provider
  const texts = [
    "Talent Market Place For MFI",
    "Speed up your hiring cycles",
    "Specialized Talent across MFI",
    "Fast & Flexible hiring",
    <span>Say Good Bye to download CV<br />Click to Hire</span>
  ];

  // Navigate to home
  const navigateToHome = () => {
    navigate('/');
  };

   useEffect(() => {
      const interval = setInterval(() => {
        setTextAnimation("fade-out");
        setTimeout(() => {
          setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
          setTextAnimation("fade-in");
        }, 500);
      }, 3000);
  
      return () => clearInterval(interval);
    }, [texts.length]);

  return (
    <div className="sign-up-container">
      <div className="sign-up-box">
      {/* Left Section */}
      <div className="sign-up-left">
       
        <img
          src={SignupImage}
          alt="Signup Illustration"
          className="sign-up-image"
        />
        <div className={`sign-up-animated-text ${textAnimation}`}>
          {texts[currentTextIndex]}
        </div>
      </div>

      {/* Right Section */}
      <div className="sign-up-right">
        {/* Back to Home Button */}
        {/* <button className="back-to-home" onClick={navigateToHome}>
              Back to Home
            </button> */}
        {isSeeker ? <SeekerSignup /> : <ProviderSignup />}
      </div>
    </div>
    </div>
  );
};

export default SignupPage;
